<template>
  <section>
    <qx-img-dialog ref="imgDialog" />
    <EditDialog ref="editDialog" @sub="handleEditSub" :orgId="orgId" />
    <DetailDialog ref="detailDialog" @previewImg="previewImg" />
    <ChooseGps
      :otherSearchData="{
        costType: 4015,
        orgId,
        standingBookType: 1,
        isVehicleFee: true,
      }"
      ref="chooseGps"
      :customShow="true"
      @change="handleEditSub"
    />
    <span class="primary cur addBtn" @click="showEdit()">添加</span>
    <span class="primary cur" @click="showChoose()">选择</span>
    <!-- 表格 -->
    <section class="tableBox" v-show="resultVal.length !== 0">
      <el-table
        v-loading="tableData.loading"
        ref="multipleTable"
        :data="resultVal"
        tooltip-effect="dark"
      >
        <!-- 常规列表项 -->
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.minW"
          :width="item.w"
        >
          <section slot-scope="scope">
            <section v-if="scope.column.property === 'detailPic'">
              <span
                class="primary cur"
                v-for="(item, index) in scope.row.detailPic"
                style="margin-right: 8px;"
                :key="index"
                @click="previewImg(item.url)"
              >{{'附件' + (index+1)}}</span>
            </section>
            <section
              v-if="scope.column.property !== 'detailPic'"
            >{{scope.row[scope.column.property]}}</section>
          </section>
        </el-table-column>
        <!-- 常规列表项 end -->
        <!-- 操作按钮 -->
        <el-table-column prop="control" label="操作" width="160">
          <template slot-scope="scope">
            <section>
              <!-- 操作按钮 -->
              <qx-permpisions permpisions>
                <span class="primary cur" @click="showDetail(scope.row)" v-if="scope.row.id">查看</span>
                <span class="primary cur" @click="showEdit(scope.row)" v-else>修改</span>
              </qx-permpisions>
              <qx-permpisions permpisions>
                <span class="primary cur" @click="del(scope.row)">删除</span>
              </qx-permpisions>
              <!-- 操作按钮 end -->
            </section>
          </template>
        </el-table-column>
        <!-- 操按钮 end -->
      </el-table>
    </section>
    <!-- 表格 end -->
  </section>
</template>

<script>
import EditDialog from './editDialog';
import DetailDialog from './detailDialog';
import ChooseGps from 'components/choose/gps';
export default {
  components: {
    EditDialog,
    DetailDialog,
    ChooseGps,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'cc',
  },
  props: {
    resultVal: {
      type: Array,
      default: () => ([]),
    },
    orgId: {
      type: Number,
    },
  },
  data () {
    return {
      tableData: { // 表格相关数据
        title: [ // 表头
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'equipmentNumber',
            label: '设备号',
          },
          {
            prop: 'serviveLoseDate',
            label: '服务失效日期',
          },
          {
            prop: 'suitTypeName',
            label: '套装类型',
          },
          {
            prop: 'suitFee',
            label: '套装费用',
          },
          {
            prop: 'detailPic',
            label: '附件',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    showDetail (item) {
      this.$refs.detailDialog.show(item);
    },
    showEdit (item) {
      this.$refs.editDialog.show(item);
    },
    showChoose () {
      if (!this.orgId) {
        this.$message.warning('请先选择费用归属');
        return;
      }
      this.$refs.chooseGps.show();
    },
    handleEditSub (item) {
      if (!item.form) { // 选择
        const resultValIds = this.resultVal.map((item) => item.id);
        item.forEach((d) => {
          if (resultValIds.indexOf(d.id) === -1) {
            d.payAmt = d.certificatesInsuranceFee || d.suitFeeDouble;
            this.resultVal.push(d);
          }
        });
      } else if (item.originData) { // 修改
        const index = this.resultVal.indexOf(item.originData);
        this.resultVal.splice(index, 1, item.form);
      } else { // 新增
        this.resultVal.push(item.form);
      }
      this.$emit('cc', this.resultVal);
      this.$emit('change', this.resultVal);
    },
    del (item) {
      this.resultVal.splice(this.resultVal.indexOf(item), 1);
      this.$emit('cc', this.resultVal);
      this.$emit('change', this.resultVal);
    },
    previewImg (url) {
      this.$refs.imgDialog.show(url);
    },
  },
};
</script>

<style scoped lang="scss">
.addBtn {
  margin-right: 16px;
}
</style>
